
import BeaconAction from '@tencent/beacon-web-sdk';
import Aegis from 'aegis-web-sdk';
import { Common } from '../consts/Common';

const uin = !window.pageProps || !window.pageProps.uid ? 'xxx' : window.pageProps.uid;
export const aegis = new Aegis({
  id: 'EPLXnIrqP17Eed6eGx', // 上报 id
  uin, // 用户唯一 ID（可选）
  websocketHack: true,
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  api: {
    reportRequest: true, // 全量上报所有接口请求，默认 false，不上报
    apiDetail: true, // 上报接口请求的时候，是否上报请求 query 和 body，默认 false，不上报
    retCodeHandler(dataStr, url) {
      if (/localhost:/.test(url)) return { isErr: false, code: 0 };
      let data = {};
      try {
        data = JSON.parse(dataStr);
      } catch (e) {
        console.error(url);
      }
      const successCode = /wuji/.test(url) ? 200 : 0;
      return {
        isErr: data.body.code === successCode,
        code: data.body.code,
      };
    },
  },
  beforeRequest(data) {
    // 入参data的数据结构：{logs: {…}, logType: "log"}
    if (data.logType === 'log' && data.logs.msg.includes('otheve.beacon.qq.com')) {
      // 拦截：日志类型为log，且内容包含otheve.beacon.qq.com的请求
      return false;
    }
    if (data.logType === 'log' && data.logs.msg.includes('localhost:')) {
      // 拦截：日志类型为log，且内容包含localhost的请求
      return false;
    }
    if (location.hostname !== Common.HOST) {
      return false;
    }
    // if (data.logType === 'log' && data.logs.msg.includes('Script error. @ (:0:0)')) {
    //   return false;
    // }
  },
});
const success = (e) => {
  console.log(`onReportSuccess : ${e}`);
};
const fail = (e) => {
  console.log(`onReportFail : ${e}`);
};
const beacon = new BeaconAction({
  appkey: '0WEB0KODCF4I6KGG', // 系统或项目id, 必填
  versionCode: '4.3.4', // 项目版本,选填
  channelID: 'channel', // 渠道,选填
  openid: 'openid', // 用户id, 选填
  isDebug: true, // 是否开启实时联调, 默认关闭,选填
  strictMode: false, // 严苛模式开关, 打开严苛模式会主动抛出异常, 上线请务必关闭!!!
  delay: 3000, // 普通事件延迟上报时间(单位毫秒), 默认3000(3秒),选填
  sessionDuration: 60 * 1000, // session变更的时间间隔, 一个用户持续30分钟(默认值)没有任何上报则算另一次 session,每变更一次session上报一次启动事件(rqd_applaunched),使用毫秒(ms),最小值30秒,选填
  onReportSuccess: success, // 上报成功回调,选填
  onReportFail: fail, // 上报失败回调,选填
});
// Object.freeze(beacon);
export const beaconInstance = beacon;
